import { Component, inject, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-league-policy',
  templateUrl: './league-policy.component.html',
  styleUrls: ['./league-policy.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, EmptyPageModule, TranslateModule],
})
export class LeaguePolicyComponent implements OnInit {
  modalController = inject(ModalController);
  private translateService = inject(TranslateService);
  
  @Input({ required: true }) leaguePolicy: any;
  @Input({ required: true }) isOwner: boolean;
  
  noPolicyText = this.translateService.instant('You don\'t have any policy');
  
  constructor() {}

  ngOnInit() {}

  async modalDissmissed() {
    await this.modalController.dismiss();
  }
}
